import { render, staticRenderFns } from "./PermissionContent.vue?vue&type=template&id=14ccdaaa&scoped=true"
import script from "./PermissionContent.vue?vue&type=script&lang=js"
export * from "./PermissionContent.vue?vue&type=script&lang=js"
import style0 from "./PermissionContent.vue?vue&type=style&index=0&id=14ccdaaa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ccdaaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14ccdaaa')) {
      api.createRecord('14ccdaaa', component.options)
    } else {
      api.reload('14ccdaaa', component.options)
    }
    module.hot.accept("./PermissionContent.vue?vue&type=template&id=14ccdaaa&scoped=true", function () {
      api.rerender('14ccdaaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PermissionContent.vue"
export default component.exports